import classnames from 'classnames'
import * as React from 'react'

import {DMColors} from '../types'

export const CHECKBOX_IDENTIFIER = 'checkbox_window'

interface Props {
  checked: boolean
  /** disables the checkbox */
  disabled?: boolean
  /** sets the checkbox in an error state */
  error?: boolean
  /** applies the "large" styling */
  large?: boolean
  onChange: (checked: boolean) => void
  /** optional class to apply to the checkbox label */
  displayClasses?: string
  labelClasses?: string
  backgroundColor?: DMColors
  dataSeleniumTarget?: string
}

/**
 * Use Checkboxes when there is a list of options and the user may select any
 * number of choices. Each checkbox is independent of all other checkboxes in the list.
 * Include a visible or hidden label as children for accessibility.
 */
const Checkbox: React.FC<Props> = ({
  checked,
  disabled,
  error,
  large,
  onChange,
  displayClasses,
  labelClasses,
  backgroundColor,
  children,
  dataSeleniumTarget,
  ...rest
}) => {
  const classes = classnames(
    'checkbox-label',
    CHECKBOX_IDENTIFIER,
    {
      'checkbox--error': error,
      'is-disabled': disabled,
    },
    backgroundColor ? `u-bg-${backgroundColor}` : '',
    displayClasses
  )
  const spanClass = classnames('checkbox', {lg: large})
  const onCheckboxChange: React.ChangeEventHandler<HTMLInputElement> = (ev) =>
    onChange(ev.target.checked)

  return (
    <label className={classes}>
      <span className={spanClass}>
        <input
          type="checkbox"
          checked={checked}
          onChange={onCheckboxChange}
          disabled={disabled}
          data-selenium-target={dataSeleniumTarget}
          {...rest}
        />
        <span className="checkbox--value" aria-hidden="true" />
      </span>
      <span className={labelClasses}>{children}</span>
    </label>
  )
}

export default Checkbox
